import { localizeDate } from '@brandfolder/utilities';
import React, { FunctionComponent } from 'react';

import { DetailedUser } from '@api/v4/private/resources/users';

import '../styles/user-details.scss';

const Detail: FunctionComponent = ({ children }) => (
  <span className="user-details__detail">{ children }</span>
);

export const UserDetails: FunctionComponent<{ user: DetailedUser }> = ({ user }) => {
  let emailModifier = '';
  if (user.created_with_saml) {
    emailModifier = ` ${bfTranslate('(SAML)')}`;
  } else if (user.created_with_sso) {
    emailModifier = ` ${bfTranslate('(SSO)')}`;
  }

  let localeDisplay = '';
  if (user.country && user.locale) {
    localeDisplay = `${user.country}, ${bfTranslate('Locale:')} ${user.locale}`;
  } else if (user.country) {
    localeDisplay = user.country;
  } else if (user.locale) {
    localeDisplay = `${bfTranslate('Locale:')} ${user.locale}`;
  }

  return (
    <div className="user-details">
      <span className="user-details__name-heading">{`${user.full_name || user.email} ${emailModifier}`}</span>
      <Detail>
        <a
          className="user-details__email"
          href={`mailto:${user.email}`}
          target="_blank"
        >
          {user.email}
        </a>
      </Detail>
      {user.title && <Detail>{user.title}</Detail>}
      {user.department && <Detail>{user.department}</Detail>}
      {user.company && <Detail>{user.company}</Detail>}
      {localeDisplay && <Detail>{localeDisplay}</Detail>}
      {user.last_active_at && <Detail>{`${bfTranslate('Last login:')} ${localizeDate(user.last_active_at)}`}</Detail>}
    </div>
  );
};